import { useEffect, useState } from 'react'
import { FetchState } from '../api-clients/api-types'

const calculateStatus = (statuses: FetchState[]) => {
  const notStarted = statuses.filter((it) => it === FetchState.NOT_STARTED)
  const errors = statuses
    .map((it, i) => {
      return { status: it, index: i }
    })
    .filter((it) => it.status === FetchState.ERROR)
  const loading = statuses.filter((it) => it === FetchState.LOADING)
  const success = statuses.filter((it) => it === FetchState.SUCCESS)

  if (notStarted.length === statuses.length) return { status: FetchState.NOT_STARTED }
  if (loading.length > 0) return { status: FetchState.LOADING }
  if (errors.length > 0 && errors.length + notStarted.length === statuses.length)
    return { status: FetchState.ERROR }
  if (errors.length > 0) return { status: FetchState.ERROR, errors: errors.map((it) => it.index) }
  if (success.length + notStarted.length === statuses.length) return { status: FetchState.SUCCESS }

  return { status: FetchState.NOT_STARTED }
}

export const useMultipleStatuses = (
  statusList: {
    status: FetchState
    fieldNames: string[]
  }[]
) => {
  const [status, setStatus] = useState({ status: FetchState.NOT_STARTED })
  const [failedElements, setFailedElements] = useState<string[]>()
  const [fetchFinished, setFetchFinished] = useState(false)

  useEffect(() => {
    const currentStatus = calculateStatus(statusList.map((it) => it.status))
    if (currentStatus.status !== status.status) {
      setStatus(currentStatus)
    }
    const failed = currentStatus?.errors?.flatMap((it) => statusList[it].fieldNames)
    if (JSON.stringify(failed) !== JSON.stringify(failedElements)) {
      setFailedElements(failed)
    }
  }, [status, statusList, failedElements])

  return {
    status,
    failedElements,
    fetchFinished,
    setFetchFinished,
  }
}
